define('lib/terms/TermsAndConditions',['require','marionette','Config'],function (require) {

    var Marionette = require('marionette');
    var Config = require('Config');

    return Marionette.Object.extend({

        _client: null,
        _config: null,
        _clientVersions: null,
        _versions: null,

        initialize: function () {
            this._config = Config.getInstance();
            this._clientVersions = this.getOption('clientTermsModel');
        },

        isSimplybookTermsAndConditionsVisible: function () {
            if (Config.getInstance().getOption('is_enterprise')) {
                return false;
            }
            if (Config.getInstance().getOption('is_simplybook_terms_disabled')) {
                return false;
            }
            return this._compareVersions(this.constructor.SIMPLYBOOK_TERMS);
        },

        isUserTermsAndConditionsVisible: function () {
            if (this._config.getPluginStatus('user_license')) {
                return this._compareVersions(this.constructor.USER_TERMS);
            }
            return false;
        },

        isPrivacyPolicyVisible: function () {
            if (this._config.getPluginStatus('user_license') && this._config.getOption('is_privacy_policy_enabled')) {
                return this._compareVersions(this.constructor.PRIVACY_POLICY);
            }
            return false;
        },

        isCancellationPolicyVisible: function () {
            if (this._config.getPluginStatus('cancelation_policy')) {
                return this._compareVersions(this.constructor.CANCELLATION_POLICY);
            }
            return false;
        },

        isPromoLettersVisible: function () {
            return this._compareVersions(this.constructor.PROMOTION_LETTERS);
        },

        _compareVersions: function (key) {
            return !this._clientVersions.get('accepted_' + key);
        }

    }, {

        SIMPLYBOOK_TERMS: 'simplybook_terms',
        USER_TERMS: 'user_terms',
        CANCELLATION_POLICY: 'cancellation_terms',
        PROMOTION_LETTERS: 'promotion_letters',
        PRIVACY_POLICY: 'privacy_policy'

    });

});
